// boletinesData.js
const boletinesData = [
    
      {
    id: 8,
    fecha: '23 de mayo de 2025',
    titulo: 'En el marco del Día del Maestro, el secretario de Gobierno, Guillermo Olivares Reyna celebró con más de 4,800 docentes de educación basica, media y superior en Ixmiquilpan y Actopan.',
    resumen: 'Olivares Reyna resaltó que los avances del estado están estrechamente ligados a la labor de los maestros y maestras hidalguenses, quienes, en contacto diario con niñas, niños y jóvenes, desempeñan un papel fundamental en la transmisión de valores, hábitos y conocimientos que les brindan mejores herramientas para enfrentar con éxito la vida.',
   imagen: '../Img/Prensa/Prensa8.jpg',
    enlace: 'https://drive.google.com/drive/u/1/folders/18ieuJP6WULnL23rYh4EZZZSt1haXPG2y',
  },
  
  
    {
    id: 7,
    fecha: '21 de mayo de 2025',
    titulo: '"Hidalgo refuerza la transparencia en infraestructura pública con la certificación del Laboratorio de Obra de la Auditoría Superior del Estado" ',
    resumen: 'Guillermo Olivares Reyna, en representación del gobernador Julio Menchaca, participó en la entrega del Certificado de Acreditación de la Unidad de Laboratorio de Obra Pública de la Auditoría Superior del Estado de Hidalgo.',
   imagen: '../Img/Prensa/Prensa7.jpg',
    enlace: 'https://drive.google.com/drive/u/1/folders/1zjkzsD1b7WPpJIhdZzNgNHbcOmb59E6i',
  },
  
  
  {
    id: 6,
    fecha: '20 de mayo de 2025',
    titulo: ' Afectaciones por lluvia en las instalaciones de la Ciudad de las Mujeres.',
    resumen: 'Se informa que derivado de las fuertes lluvias registradas el pasado martes 20 de mayo, las instalaciones de la Ciudad de las Mujeres en Tepeji del Río han sufrido afectaciones que impiden brindar atención al público de manera adecuada y segura.         Por tal motivo, se suspende temporalmente la atención a usuarias hasta nuevo aviso, con el objetivo de salvaguardar la integridad de todas las personas que acuden a nuestros servicios, así como del personal que labora en nuestras instalaciones.      Agradecemos su comprensión y colaboración ante esta situación. Les invitamos a mantenerse atentas y atentos a nuestros canales oficiales para futuras actualizaciones sobre la reanudación de actividades.',
   imagen: '../Img/Prensa/Prensa6.jpg',
    enlace: 'https://drive.google.com/drive/folders/1reV0Glsas_b0N7uq1plirnneTJCKnUfX?usp=sharing',
  },
    {
    id: 5,
    fecha: '20 de mayo de 2025',
    titulo: 'Comunicado de Protección Civil y Gestión de Riesgos: Condiciones Meteorológicas para el 20 de mayo de 2025',
    resumen: '📢 La Subsecretaría de Protección Civil y Gestión de Riesgos informa a la población hidalguense sobre las condiciones meteorológicas pronosticadas para este martes 20 de mayo de 2025, derivadas de sistemas atmosféricos en interacción que afectan al centro del país.',
   imagen: '../Img/Prensa/Prensa5.jpg',
    enlace: 'https://www.facebook.com/photo?fbid=1010393767847258&set=a.323011916585450',
  },
    {
    id: 4,
    fecha: '19 de mayo de 2025',
    titulo: 'Árbol cae sobre vehículo en el bulevar Santa Catarina por fuertes vientos',
    resumen: 'La tarde de este lunes, los fuertes vientos registrados en la capital hidalguense provocaron la caída de un árbol sobre el bulevar Santa Catarina, en dirección a Pitahayas, en el municipio de Pachuca de Soto.',
    imagen: '../Img/Prensa/Prensa4.jpg',
    enlace: 'https://drive.google.com/drive/u/1/folders/1g1wcaxJur6EsbANjU_Wyzb5ET7gRU21S',
  },

    {
    id: 3,
    fecha: '06 de mayo de 2025',
    titulo: 'Fortaleciendo el Transporte en la Región Tula-Tepeji: Diálogo entre Autoridades y Transportistas en Atitalaquia',
    resumen: 'En Atitalaquia, el secretario de Gobierno, Guillermo Olivares Reyna, atendió la invitación a la Reunión de transportistas con autoridades estatales y municipales de la región Tula-Tepeji, convocada por el presidente de la Unión de Transportistas Hidalguenses por la Transformación, A.C. (UTXT), Juan Alberto Ávila Guerra.',
    imagen: '../Img/Prensa/Prensa3.jpg',
    enlace: 'https://www.facebook.com/share/p/1Fdo8Qhq7t/',
  },

  {
    id: 2,
    fecha: '06 de mayo de 2025',
    titulo: 'Proteccion Civil de Hidalgo y CENAPRED: Capacitación en Atlas de Riesgos',
    resumen: 'Con gran orgullo recibimos a la Dra. Cecilia Izcara Treviño, Directora de Análisis y Gestión de Riesgos del CENAPRED, quien por primera vez en el estado impartió una valiosa capacitación sobre el uso y manejo de los Atlas de Riesgos Municipales y el Portal del Atlas Nacional de Riesgos.',
    imagen: '../Img/Prensa/Prensa2.jpg',
    enlace: 'https://www.facebook.com/share/p/19BEDncaBd/',
  },

  {
    id: 1,
    fecha: '03 de mayo de 2025',
    titulo: 'Gabinete de Seguridad informó resultados de diferentes operativos en la materia',
    resumen: 'En rueda de prensa encabezada por el secretario de Gobierno, Guillermo Olivares Reyna, se dieron a conocer los resultados de un operativo en Acaxochitlán y los avances en seguridad y localización de personas en Hidalgo.',
    imagen: '../Img/Prensa/Prensa1.jpg',
    enlace: 'https://drive.google.com/drive/u/1/folders/1g1wcaxJur6EsbANjU_Wyzb5ET7gRU21S',
  },







  
];

export default boletinesData;
